import React, {Component} from "react"
import PropTypes from "prop-types"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import {TeamReport} from "@irati/types"

import {Quadrant} from "./quadrants"
import TeamBreakdown from "./TeamBreakdown"

interface Props extends InjectIntl {
  quadrant: Quadrant | undefined,
  bottomLeftTeams: TeamReport[],
  topLeftTeams: TeamReport[],
  bottomRightTeams: TeamReport[],
  topRightTeams: TeamReport[],
  source: string
}

class Footer extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  getValueForQuadrant = (bottomLeft: string, topLeft: string, bottomRight: string, topRight: string) => {
    const {quadrant} = this.props
    if (quadrant === Quadrant.BottomLeftQuadrant) {
      return bottomLeft
    }
    if (quadrant === Quadrant.TopLeftQuadrant) {
      return topLeft
    }
    if (quadrant === Quadrant.BottomRightQuadrant) {
      return bottomRight
    }
    if (quadrant === Quadrant.TopRightQuadrant) {
      return topRight
    }
    return null
  }

  render() {
    const {bottomLeftTeams, topLeftTeams, bottomRightTeams, topRightTeams, source} = this.props

    return (
      <Card flush marginTop={4}>
        <TeamBreakdown
          title={this.getValueForQuadrant(
            "admin.components.teamEngagement.bottomLeftQuadrant.text",
            "admin.components.teamEngagement.topLeftQuadrant.text",
            "admin.components.teamEngagement.bottomRightQuadrant.text",
            "admin.components.teamEngagement.topRightQuadrant.text"
          )}
          teams={this.getValueForQuadrant(bottomLeftTeams, topLeftTeams, bottomRightTeams, topRightTeams)}
          source={source} />
      </Card>
    )
  }
}

export default injectIntl(Footer)
